export default __webpack_public_path__ + "static/media/sticker-Y.af29e89f.png";